/* SL4 Header (ajustes cliente p12/p58)
   1. Scroll: cuando el announcement bar sale de vista, la pill del header
      sube al borde superior y se vuelve translúcida con blur
      (clase .sl4-header--scrolled). El announcement se desplaza con el
      contenido porque vive en el flujo normal; el header es fixed y no
      ocupa altura en flujo, así que nada salta.
   2. Drawer móvil: el hamburger es toggle (abre/cierra); announcement y
      header quedan visibles sobre el drawer. */
(function () {
  var header = document.querySelector('.sl4-header');
  var announcement = document.querySelector('.sl4-announcement');
  var hamburger = document.getElementById('sl4-hamburger');
  var mobileNav = document.getElementById('sl4-mobile-nav');

  if (header) {
    var ticking = false;
    var update = function () {
      var threshold = announcement ? announcement.offsetHeight : 40;
      header.classList.toggle('sl4-header--scrolled', window.scrollY > threshold);
      ticking = false;
    };
    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(update);
        }
      },
      { passive: true }
    );
    update();
  }

  if (hamburger && mobileNav) {
    hamburger.addEventListener('click', function () {
      var open = mobileNav.classList.toggle('is-open');
      hamburger.classList.toggle('is-open', open);
      hamburger.setAttribute('aria-expanded', open ? 'true' : 'false');
      hamburger.setAttribute('aria-label', open ? 'Cerrar menú' : 'Abrir menú');
      document.body.style.overflow = open ? 'hidden' : '';
    });

    /* Cerrar al navegar dentro del drawer (links ancla / misma página). */
    mobileNav.addEventListener('click', function (event) {
      if (event.target.closest('a')) {
        mobileNav.classList.remove('is-open');
        hamburger.classList.remove('is-open');
        hamburger.setAttribute('aria-expanded', 'false');
        hamburger.setAttribute('aria-label', 'Abrir menú');
        document.body.style.overflow = '';
      }
    });
  }
})();
